<template>
    <a-card :bordered="false" :loading="loadingCard">
      <h2 align="left" style="margin-top: -5px;">评审委员会</h2>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a v-if='!userRecommendEnd' @click="recommend(record)" style="margin-left: 5px">推荐为组长</a>
        </span>

      </a-table>
    </a-card>
</template>

<script>
  import { httpAction,getAction,postAction,deleteAction,putAction } from '@/api/manage'
  import {FzisListMixin} from '@/mixins/FzisListMixin'
  import { mapActions, mapGetters,mapState } from 'vuex'

  export default {
    name: "RecommendCommittee",
    mixins: [FzisListMixin],
    data () {
      return {
        id:"",
        disabled:true,
        disabled2:false,
        loadingCard : false,
        tenderProjectInfo:{},
        projectInfo:{},
        sectionInfo:{},
        delFlag: "0",
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '姓名',
            align: "center",
            dataIndex: 'expertName'
          },
          {
            title: '得票数',
            align: "center",
            dataIndex: 'voteCount'
          },
          {
            title: '是否推荐完成',
            align: "center",
            dataIndex: 'recommendEnd',
            customRender: (t, r, index) => {
              if (r.idCardNumber == this.username && t != "1") {
              // if (r.idCardNumber == '350181199508107756' && t != "1") {
                this.userRecommendEnd = false;
              }
              if (r.idCardNumber == this.username && t == "1") {
              // if (r.idCardNumber == '350181199508107756' && t == "1") {
                this.userRecommendEnd = true;
              }
              if (t == "1") {
                return '是';
              } else {
                return '否';
              }
            }
          },
          {
            title: '任职',
            align: "center",
            dataIndex: 'expertType',
            customRender: function(text) {
              if (text == "0") {
                return '成员'
              } else if (text == "1") {
                return '组长'
              } else {
                return text
              }
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          },
        ],
        disableMixinCreated: true,
        url: {
          list: "/ebid-ce/boCommitteeMem/list",
        },
        userRecommendEnd: true,
        userName: null,
      }
    },
    filters: {
    },
    created(){
      this.username = this.userInfo.username
      this.queryParam.bidProjectId = this.bidProjectId;
      this.queryParam.sectionId = this.sectionId;
      this.queryParam.delFlag = this.delFlag;
      this.isorter.column = 'expertType';
      this.isorter.order = 'desc';
      this.loadData();
    },
    props: ['workflowInstanceId','sectionId','instStepId','bidProjectId'],
    computed: {
      ...mapGetters(['nickname', 'userInfo']),
    },
    methods: {
      recommend(record){
        var that = this;
        that.$confirm({
          title: '提示',
          content: '确认要推荐专家“'+record.expertName+'”为组长吗？',
          onOk() {
            that.userRecommendEnd = true;
            postAction("/ebid-ce/boCommitteeMem/recommendTeamCaptain/" + that.instStepId + "/" + record.id,{}).then(res=>{
              if(res.success){
                that.userRecommendEnd = true;
                that.$emit('getNewWfInst');
                that.$message.success("推荐专家提交成功！");
                that.loadData();
              }else {
                that.userRecommendEnd = false;
                that.$message.warning(res.message)
              }
            })
          },
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>